import { render, staticRenderFns } from "./TransferProcess.vue?vue&type=template&id=e5f3b3c8&scoped=true"
import script from "./TransferProcess.vue?vue&type=script&lang=ts"
export * from "./TransferProcess.vue?vue&type=script&lang=ts"
import style0 from "./TransferProcess.vue?vue&type=style&index=0&id=e5f3b3c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f3b3c8",
  null
  
)

export default component.exports